import { useState, useEffect } from 'react';

const useTranslationCheck = (idiomaBase = 'es') => {
  const [isTranslated, setIsTranslated] = useState(false);

  useEffect(() => {
    const checkTranslation = () => {
      const html = document.documentElement;
      const body = document.body;

      // ---------------------------------------------------------
      // 1. DETECCIÓN GOOGLE CHROME / CHROMIUM
      // ---------------------------------------------------------
      // Chrome añade clases 'translated-ltr' o 'translated-rtl' al html
      const googleClass = html.classList.contains('translated-ltr') || 
                          html.classList.contains('translated-rtl');
      
      // A veces cambian el atributo 'lang' (ej: de 'es' a 'en')
      // Verificamos si existe 'lang', si no es vacío y si es diferente al base
      const currentLang = html.getAttribute('lang');
      const langChanged = currentLang && currentLang !== '' && !currentLang.startsWith(idiomaBase);

      // ---------------------------------------------------------
      // 2. DETECCIÓN MICROSOFT EDGE / BING (Tu caso actual)
      // ---------------------------------------------------------
      // Edge inyecta atributos '_istranslated="1"' o hashes '_mst...'
      // Usamos querySelector para ver si EXISTE ALGÚN elemento así en toda la web
      const edgeMark = document.querySelector('[_istranslated="1"]');
      const edgeHash = document.querySelector('[_msttexthash]');

      // ---------------------------------------------------------
      // 3. DETECCIÓN POR "BASURA" EN EL DOM (Heurística)
      // ---------------------------------------------------------
      // Muchos traductores envuelven el texto en etiquetas <font>
      // Hoy en día nadie usa <font> en desarrollo web. Si hay muchas, es un traductor.
      const fontTags = document.getElementsByTagName('font');
      const hasFontTags = fontTags.length > 0;

      // Detectar inyección de estilos de Google en el body (barra superior)
      const googleBar = body.style.top === '40px' || html.style.top === '40px';


      // --- EVALUACIÓN FINAL ---
      if (googleClass || langChanged || edgeMark || edgeHash || hasFontTags || googleBar) {
        if (!isTranslated) setIsTranslated(true);
      } else {
        // Opcional: Si quieres que vuelva a false si el usuario quita la traducción
        // (Nota: Algunos traductores no limpian bien el DOM al desactivarse)
        if (isTranslated) setIsTranslated(false);
      }
    };

    // Usamos un intervalo de 1 segundo. 
    // Es ligero para el navegador y asegura detectar cambios profundos (como los de Edge)
    // que un MutationObserver en el root podría pasar por alto.
    const intervalId = setInterval(checkTranslation, 1000);

    // Chequeo inicial
    checkTranslation();

    // Limpieza
    return () => clearInterval(intervalId);
  }, [isTranslated, idiomaBase]);

  return isTranslated;
};

export default useTranslationCheck;